import { render } from "./UserTabsView.vue?vue&type=template&id=96f895ac&scoped=true&ts=true"
import script from "./UserTabsView.vue?vue&type=script&lang=ts"
export * from "./UserTabsView.vue?vue&type=script&lang=ts"

import "./UserTabsView.vue?vue&type=style&index=0&id=96f895ac&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f895ac"]])

export default __exports__